__turbopack_context__.v({
  "button": "Buttons-module__yBziha__button",
  "menuControl": "Buttons-module__yBziha__menuControl",
});
